import { MetricKind, MetricValue } from '@/webapi/models';

export interface StoreEnrichMetricDefinition {
  name: string;
  compute: (metrics: MetricValue[]) => number;
}

export const customEnrichMetrics: Record<
  string,
  Record<string, StoreEnrichMetricDefinition>
> = {
  DOLLAR_SHAVE_CLUB_STORE: {
    NEXT_BOX_AND_TRANSACTIONS: {
      name: `Next Box + Transactions`,
      compute: (metrics) => {
        const transactions =
          metrics.find((m) => m.name === MetricKind.TRANSACTIONS)?.value ?? 0;
        const custom1 =
          metrics.find((m) => m.name === MetricKind.CUSTOM_1)?.value ?? 0;
        const custom2 =
          metrics.find((m) => m.name === MetricKind.CUSTOM_2)?.value ?? 0;
        return transactions + custom1 + custom2;
      },
    },
    NEXT_BOX_AND_TRANSACTIONS_RATE: {
      name: `Next Box + Transactions Rate`,
      compute: (metrics) => {
        const sessions =
          metrics.find((m) => m.name === MetricKind.SESSIONS)?.value ?? 0;
        const transactions =
          metrics.find((m) => m.name === MetricKind.TRANSACTIONS)?.value ?? 0;
        const custom1 =
          metrics.find((m) => m.name === MetricKind.CUSTOM_1)?.value ?? 0;
        const custom2 =
          metrics.find((m) => m.name === MetricKind.CUSTOM_2)?.value ?? 0;
        if (Number.isFinite(sessions)) {
          return (transactions + custom1 + custom2) / sessions;
        }
        return 0;
      },
    },
  },
};

export function mergeStoreMetrics(
  moreMetrics: MetricKind[] = [],
  storeMetrics: string[] = [],
): MetricKind[] {
  if (!storeMetrics || storeMetrics.length === 0) return moreMetrics;
  const unique = new Set<MetricKind>(moreMetrics);
  storeMetrics.forEach((m) => {
    unique.add(m as MetricKind);
  });
  return Array.from(unique);
}

export const getStoreCustomEnrich = (alias: string) =>
  customEnrichMetrics?.[alias] || {};

export const getStoreCustomEnrichKeys = (alias: string) =>
  customEnrichMetrics?.[alias] ? Object.keys(customEnrichMetrics[alias]) : [];
